import { render, staticRenderFns } from "./VSvg.vue?vue&type=template&id=a07842ee&"
import script from "./VSvg.vue?vue&type=script&lang=js&"
export * from "./VSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports